<template>
<div>

      <van-field v-model="newpost.ana" label="Anagrup" />
      <van-field v-model="newpost.alias" label="AltGrup" />
      <van-field v-model="newpost.genislik" label="Genişlik" />
      <van-field v-model="newpost.derinlik"  label="Derinlik" />
      <van-field v-model="newpost.yukseklik"  label="Yükseklik" />
      <van-field v-model="newpost.agirlik"  label="Ağırlık" />

<van-image
  width="10rem"
  height="10rem"
  fit="contain"
 :src="$request.domain+newpost.img"
/>
         <div style="height:70px"></div>
         <van-tabbar v-model="active">
          <van-tabbar-item name="Home" to="/" icon="wap-home-o">Home</van-tabbar-item>
          <van-tabbar-item name="Servis" to="/servis" icon="todo-list-o">Servis</van-tabbar-item>
          <van-tabbar-item name="Sepet" to="/sepet" icon="cluster-o">Ekibim</van-tabbar-item>
          <van-tabbar-item name="Depom" to="/depo" icon="apps-o">Depom</van-tabbar-item>
          <van-tabbar-item name="Cihaz" to="/gruplama" icon="fire-o">Cihaz</van-tabbar-item>
          <van-tabbar-item name="Hesabım" to="/hesap" icon="user-o">Hesap</van-tabbar-item>
         </van-tabbar>
<van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
</div>
</template>

<script>
import { Popup } from 'vant';
import { decode} from 'js-base64';

export default {
  data() {
    return {
      list: [],
      isLoading: false,
      active:'altgrup',
      depolar: [],
      showPicker: false,
      ayar:this.$request.ayar(),
      value1:'',
      popshow:false,
      show:false,
      depom:decode(this.$request.ayar().genel.d),
      kisa:decode(this.$request.ayar().genel.s),
      id:this.$route.params.id,
        newpost:
              {
                kodu:'',
                alias:'',
                genislik:0,
                derinlik:0,
                yukseklik:0,
                agirlik:0,
                img:'',
                ana:''
             }      
    };
  },
  computed:{
    // filteredList() {
    //   return this.list.filter(post => {
    //     return post.sto_isim.toLowerCase().includes(this.value1.toLowerCase())
    //   })
    // }    
  },  
  created(){
    this.show = true
    this.onLoad();
  },
  methods: {

        onLoad() {
         this.$request.get("/altgrup2/"+this.ayar.firmaid+"/"+this.id)
            .then(
              res => {
                this.newpost.kodu = res.results[0].mkod
                this.newpost.ana = res.results[0].alias
                this.newpost.alias = res.results[0].malias
                this.newpost.genislik = res.results[0].genislik+' Santimetre'
                this.newpost.derinlik = res.results[0].derinlik+' Santimetre'
                this.newpost.yukseklik = res.results[0].yukseklik+' Santimetre'
                this.newpost.agirlik = res.results[0].agirlik+' Kilogram'
                this.newpost.img = res.results[0].foto                
              this.show=false;

            })
        },

       
  }
};
</script>


// WEBPACK FOOTER //
// src/components/cihaz/altgrupdetay.vue